import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const VisibilityScoreTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>
                        Aggregated score representing the overall brand <br />
                        visibility. It is calculated based on the brand's mentions, <br />
                        citation, sentiment score and ranking within LLM responses. <br />
                        Only applies to responses from organic prompts.
                  </p>
            </BaseTooltip>
      );
};
